import dayjs from 'dayjs';
import { orderMoment } from '../serviceorder/orderMobileUtils';

/**
 * Apoio comum das telas mobile de Orçamentos (`prototipos-mobile/orcamentos/*`).
 * Só apresentação: rótulos/cores de status e datas derivadas.
 */

// Status reais da API (`StatusChip domain="serviceQuote"`) -> rótulo, tom do `.pill` e cor da faixa lateral.
const STATUS_VIEW = {
    novo: { label: 'Novo', tone: undefined, color: '#94a3b8', open: true },
    'enviado para cliente': { label: 'Enviado', tone: 'info', color: '#2563eb', open: true },
    'aguardando aprovacao': { label: 'Aguardando aprovação', tone: 'warning', color: '#f59e0b', open: true },
    aprovado: { label: 'Aprovado', tone: 'success', color: '#16a34a', open: false },
    'ordem gerada': { label: 'Ordem Gerada', tone: 'purple', color: '#8b5cf6', open: false },
};

// Mesma normalização de `statusKeyOf` em `pages/service_quotes/Operator.js`.
export function quoteStatusKey(status) {
    const s = String(status || '').toLowerCase();
    if (s.includes('ordem gerada') || s.includes('convertido')) return 'ordem gerada';
    if (s.includes('aguardando')) return 'aguardando aprovacao';
    if (s.includes('aprovado')) return 'aprovado';
    if (s.includes('enviado') || s.includes('cliente')) return 'enviado para cliente';
    return 'novo';
}

export function quoteStatusView(status) {
    return STATUS_VIEW[quoteStatusKey(status)];
}

// "Válido até": a API não guarda a validade; a tela de operação deriva +7 dias da data do orçamento.
export function quoteValidUntil(value) {
    const m = orderMoment(value);
    return m ? m.add(7, 'day') : null;
}

// Texto curto do cartão da lista: "Válido até 20/10" (em aberto) ou "Criado 14/10".
export function quoteDateLabel(quote) {
    // Mesmo relógio local da coluna "Data" da lista desktop (`created_at`).
    const created = quote.created_at ? dayjs(quote.created_at) : null;
    if (!created || !created.isValid()) return '—';
    if (quoteStatusView(quote.status).open) return `Válido até ${created.add(7, 'day').format('DD/MM')}`;
    return `Criado ${created.format('DD/MM')}`;
}
